<template>
    <div class="d-flex flex-column border border-secondary p-2 mb-2">
        <div class="d-flex">
            <a class="btn btn-link" :href="'/download/file-task/' + file.id" target="_blank"><i class="fa fa-download"></i> {{ file.name }}</a>
        </div>
        <div class="d-flex justify-content-center">
            <h5><b-badge class="mr-2" pill variant="secondary">{{ file.user.name }}</b-badge>
            <b-badge class="ml-2" pill variant="secondary">{{ file.created_at | datetime }}</b-badge></h5>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        file: {
            type: Object,
            required: true
        }
    }
}
</script>